"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const pino_1 = __importDefault(require("pino"));
/**
 * Logger instance for server-side runtime (e.g. API routes)
 */
exports.logger = (0, pino_1.default)({ enabled: process.env.NODE_ENV !== 'test' }).child({
    module: '@side/identity-token',
});
